/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
  (function () {
    const pageTopBtn = document.querySelector('.pagetop');
    const cartSide = document.getElementById('cart_side');
    if (!pageTopBtn) return;

    // Show/hide button on scroll
    window.addEventListener('scroll', function () {
      if (window.scrollY > 150) {
        pageTopBtn.style.display = 'block';
      } else {
        pageTopBtn.style.display = 'none';
      }
    });

    // Smooth scroll to top on click
    const link = pageTopBtn.querySelector('a');
    if (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
    if (cartSide) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 150) {
          cartSide.style.display = 'block';
        } else {
          cartSide.style.display = 'none';
        }
      });

      const cartLink = cartSide.querySelector('a.cartLink');
      if (cartLink) {
        cartLink.addEventListener('click', function (e) {
          e.preventDefault();
          const target = document.querySelector('#product-single__meta');
          if (target) {
            const offset = 80;
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
            //target.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }
    }
    // ===== Smooth scroll for article anchor links =====
    const anchorLinks = document.querySelectorAll('a.anchor_href');
    anchorLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
           const y = target.getBoundingClientRect().top + window.pageYOffset - 70; // offset 70px
      window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    });
  })();
})();
